import { View, Text } from 'react-native';
import React from 'react';
import { ProductDetailStyles } from './styles';
import { getPriceText } from '../../utils/NumberUtility';
import { isBlank } from '../../utils/BooleanUtility';
import { ShowShopifySkuCodeOnProductPage } from '../../config/Constants';


const ShopifyProductSkuCode = ({ skuCode }) => {
  if (!ShowShopifySkuCodeOnProductPage || isBlank(skuCode)) return null;
  return (
    <View style={ProductDetailStyles.shopifySkuCodeContainer}>
      <Text style={ProductDetailStyles.shopifySkuCodeText}>SKU: {skuCode}</Text>
    </View>
  );
};

export default React.memo(ShopifyProductSkuCode);
